import * as React from "react";
import { Accordion, Box, AccordionSummary, AccordionDetails, } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/system";
import { ColorSelectorWrapper } from "./ColorSelectorWrapper";
import { LegendComp } from "../BreakPoint/Legend";
import defaultColorTables from "../color-tables.json";
import { RGBToHex } from "../Utils/legendCommonFunction";
import { getColorSelectorPosition } from "../Utils/legendCommonFunction";
var StyledBox = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        margin: theme.spacing(3),
        width: theme.spacing(38),
        border: "1px solid #dadada",
        "& .MuiButtonBase-root.MuiAccordionSummary-root": {
            minHeight: 30,
            marginLeft: -15,
        },
        "& .MuiAccordionSummary-content": {
            height: 0,
            marginTop: 0,
        },
        "& .expandMoreIcon": {
            marginRight: 8,
            marginTop: -4,
        },
        "& .MuiPaper-root.MuiAccordion-root.Mui-expanded.MuiAccordion-rounded.MuiPaper-elevation1.MuiPaper-rounded": {
            border: "1px solid #dadada",
        },
        "& .makeStyles-accordion-1 .MuiAccordionDetails-root": {
            marginTop: -15,
        },
        "& .MuiAccordionDetails-root": {
            display: "block",
            "& .colorScalesDetails": {
                marginLeft: -27,
            },
        },
        "& .MuiAccordion-root.Mui-expanded": {
            margin: "auto",
        },
        "& h5": {
            marginTop: 0,
            marginLeft: -7,
            height: 0,
        },
    });
});
export var ColorSelectorAccordion = function (props) {
    var _a, _b;
    var containerRef = React.useRef(null);
    var colorScaleBreakpoints = [];
    var _c = React.useState(""), customScalesName = _c[0], setCustomScalesName = _c[1];
    var _d = React.useState([]), duplicatedData = _d[0], setDuplicatedData = _d[1];
    var getColorScaleArray;
    if (customScalesName) {
        getColorScaleArray = defaultColorTables.find(function (value) {
            return value.name === customScalesName;
        });
    }
    getColorScaleArray === null || getColorScaleArray === void 0 ? void 0 : getColorScaleArray.colors.forEach(function (value) {
        // return the color and breakPoint needed to draw the legend
        colorScaleBreakpoints.push({
            // to support discrete color for continous data
            position: value[0],
            color: RGBToHex(value).color,
        });
    });
    var breakpointValues = ((_a = props.breakPointFlag) === null || _a === void 0 ? void 0 : _a.length) > 0
        ? props.breakPointFlag
        : colorScaleBreakpoints;
    var editedData = React.useCallback(function (data) {
        props.getEditedBreakPoint({
            colorArray: data.colorArray,
            customizeFlag: data.customizeFlag,
        });
    }, [props]);
    var isCustomScale = React.useCallback(function (data) {
        setCustomScalesName(data);
    }, []);
    var getDuplicatedLegendData = React.useCallback(function (data) {
        setDuplicatedData(data);
    }, []);
    var _e = React.useState("panel1"), expanded = _e[0], setExpanded = _e[1];
    var handleChange = function (panel) {
        return function (_event_, newExpanded) {
            setExpanded(newExpanded ? panel : false);
        };
    };
    if ((duplicatedData === null || duplicatedData === void 0 ? void 0 : duplicatedData.length) > 0) {
        var testComponent = duplicatedData === null || duplicatedData === void 0 ? void 0 : duplicatedData.map(function (val, index) {
            return (React.createElement(LegendComp, { colorScaleBreakpoints: val, editedData: editedData, isModal: props.isModal, handleModalClick: props.handleModalClick, customScalesName: val[0].name, key: index }));
        });
    }
    return (React.createElement("div", { ref: containerRef, className: "Container", style: {
            width: "316px",
            position: "absolute",
            zIndex: 1000,
            top: getColorSelectorPosition(props.cssLegendStyles, props.isHorizontal, props.legendScaleSize).top,
            left: getColorSelectorPosition(props.cssLegendStyles, props.isHorizontal, props.legendScaleSize).left,
            right: getColorSelectorPosition(props.cssLegendStyles, props.isHorizontal, props.legendScaleSize).right,
            bottom: getColorSelectorPosition(props.cssLegendStyles, props.isHorizontal, props.legendScaleSize).bottom,
        } },
        !props.isModal && (React.createElement("div", { style: { cursor: "pointer" } },
            React.createElement(CancelIcon, { style: {
                    position: "absolute",
                    top: "-10px",
                    right: "-10px",
                    cursor: "pointer",
                    color: "#007079",
                }, onMouseOver: function (e) {
                    e.preventDefault();
                    var target = e.target;
                    target.style.color = "#1099a5";
                }, onMouseOut: function (e) {
                    var target = e.target;
                    target.style.color = "#007079";
                }, onClick: props.setIsOpen }))),
        React.createElement(StyledBox, null,
            React.createElement(Accordion, { expanded: expanded === "panel1", onChange: handleChange("panel1") },
                React.createElement(AccordionSummary, { className: "colorScaleSummary" },
                    React.createElement(ExpandMoreIcon, { className: "expandMoreIcon", fontSize: "medium" }),
                    React.createElement("h5", null, "Color Scales")),
                React.createElement(AccordionDetails, { className: "colorScaleDetails" },
                    React.createElement(ColorSelectorWrapper, { useColorTableColors: true, newColorScaleData: props === null || props === void 0 ? void 0 : props.newColorScaleData, colorTables: props === null || props === void 0 ? void 0 : props.colorTables, currentLegendName: props === null || props === void 0 ? void 0 : props.currentLegendName, isCustomScale: isCustomScale, getDuplicatedLegendData: getDuplicatedLegendData }),
                    (((_b = breakpointValues === null || breakpointValues === void 0 ? void 0 : breakpointValues.colorArray) === null || _b === void 0 ? void 0 : _b.length) > 0 ||
                        (breakpointValues === null || breakpointValues === void 0 ? void 0 : breakpointValues.length) > 0) &&
                        customScalesName && (React.createElement(React.Fragment, null,
                        React.createElement("h5", null, "Custom scales: "),
                        React.createElement("div", { style: { marginTop: -12, marginBottom: -15 } },
                            testComponent,
                            React.createElement("br", null)))))),
            React.createElement(Accordion, { expanded: expanded === "panel2", onChange: handleChange("panel2") },
                React.createElement(AccordionSummary, null,
                    React.createElement(ExpandMoreIcon, { className: "expandMoreIcon", fontSize: "medium" }),
                    React.createElement("h5", null, "Color Sampling")),
                React.createElement(AccordionDetails, null,
                    React.createElement("h5", null, "Range :"),
                    React.createElement(ColorSelectorWrapper, { useRange: true, getRange: props === null || props === void 0 ? void 0 : props.getRange, isCont: props === null || props === void 0 ? void 0 : props.isCont, selectedRangeType: props === null || props === void 0 ? void 0 : props.selectedRangeType }),
                    React.createElement("h5", { style: { marginTop: 10 } }, "Interpolations :"),
                    React.createElement(ColorSelectorWrapper, { useInterpolation: true, isCont: props === null || props === void 0 ? void 0 : props.isCont, getInterpolation: props === null || props === void 0 ? void 0 : props.getInterpolation, selectedInterpolationType: props === null || props === void 0 ? void 0 : props.selectedInterpolationType }))))));
};
//# sourceMappingURL=ColorSelectorAccordion.js.map